import { render, staticRenderFns } from "./SPButtonHistoryBack.vue?vue&type=template&id=01bc6aef&scoped=true"
import script from "./SPButtonHistoryBack.vue?vue&type=script&lang=js"
export * from "./SPButtonHistoryBack.vue?vue&type=script&lang=js"
import style0 from "./SPButtonHistoryBack.vue?vue&type=style&index=0&id=01bc6aef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bc6aef",
  null
  
)

export default component.exports